import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "CircleFilled.svg",
  "use": "CircleFilled.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"CircleFilled.svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 56C18.7452 56 8 45.2548 8 32C8 18.7452 18.7452 8 32 8C45.2548 8 56 18.7452 56 32C56 45.2548 45.2548 56 32 56Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol